module.exports = __webpack_public_path__ + "static/DemeterGreen-690b59f61edc289770c195262482dbef.png";